import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('footer-newsletter', () => import(/* webpackMode: "lazy" */'./footer-newsletter'));
